import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { EventsService } from "../../../_services/eventsServices/events.service";

import { NgbModal, NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";

import { CreateParentEventFormComponent } from "../create-parent-event-form/create-parent-event-form.component";
import { EventFormCustomFormType } from "../event-page-models/event-form-custom-form-type";
import { LoggerService } from "../../../modules/logger/logger.service";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";

@Component({
  selector: "create-parent-event-form-custom",
  templateUrl: "./create-parent-event-form-custom.component.html",
  styleUrls: [
    "../create-parent-event-form/create-parent-event-form.component.scss",
    "./create-parent-event-form-custom.component.scss",
  ],
})
export class CreateParentEventFormCustomComponent
  extends CreateParentEventFormComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild("formTabSet") public formTabSet: NgbTabset;
  @Input("modalEventId") public modalEventId: "new" | string;
  @Input("isCloneEvent") public isCloneEvent: boolean = false;
  @Input("EventFormCustomFormType")
  public eventFormCustomFormType: EventFormCustomFormType;
  @Output("modalAction") public modalAction: EventEmitter<"close" | "save"> =
    new EventEmitter<"close" | "save">();

  constructor(
    protected eventsService: EventsService,
    protected dataService: DataService,
    protected authenticationService: AuthenticationService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected modalService: NgbModal,
    protected changeDetectorRef: ChangeDetectorRef,
    protected logger: LoggerService,
    protected sessionManagerService: SessionManagerService
  ) {
    super(
      eventsService,
      dataService,
      authenticationService,
      activatedRoute,
      router,
      modalService,
      changeDetectorRef,
      logger,
      sessionManagerService
    );
  }

  public get hideSkipAndSaveButton() {
    switch (this.eventFormCustomFormType) {
      case EventFormCustomFormType.Michlol:
        return this.formTabSet && this.formTabSet.activeId !== "tab-2";
      case EventFormCustomFormType.common:
      default:
        return this.formTabSet && this.formTabSet.activeId !== "tab-3";
    }
  }

  public get showQuestionsTab() {
    return this.eventFormCustomFormType !== EventFormCustomFormType.Michlol;
  }
  public navigateForm(number: number) {
    const tabNumber = +this.formTabSet.activeId.replace("tab-", "");
    let newTabNumber = tabNumber + number;
    if (!this.showQuestionsTab && newTabNumber === 3) {
      newTabNumber = tabNumber + number * 2;
    }
    if (newTabNumber < 1 || newTabNumber > 4) {
      return;
    }
    this.formTabSet.select(`tab-${newTabNumber}`);
  }

  public setSpecialEventName() {
    switch (this.eventFormCustomFormType) {
      case EventFormCustomFormType.common:
        return "ארוע";
      case EventFormCustomFormType.Michlol:
        return "מכלול";
      case EventFormCustomFormType.Donation:
      case EventFormCustomFormType.DmeyHaver:
      case EventFormCustomFormType.Product:
      case EventFormCustomFormType.NestProduct:
      default:
        return "ארוע";
    }
  }
  public ngOnInit() {
    super.ngOnInit();
    this.specificEventName = this.setSpecialEventName();
  }
  public ngOnDestroy() {
    super.ngOnDestroy();
  }
  public ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  public async submit(): Promise<void> {
    this.preSubmitAction();
    return super.submit();
  }
  private preSubmitAction() {
    switch (this.eventFormCustomFormType) {
      case EventFormCustomFormType.Michlol:
        const patchMichlolMissingValues = {
          AllChildEvents: {
            ActiveChildEvents: [
              {
                eventPrice: 0,
                priceChanges: [],
              },
            ],
          },
          parentEventMain: {
            parentEventDetails: {
              eventType: {
                customValue: 10,
                icon: null,
                key: 10,
                text: "מכלול",
              },
            },
          },
        };
        this.parentEventMegaForm.patchValue(patchMichlolMissingValues);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-form-custom/create-parent-event-form-custom.component.ts